export default {
  bodyParams: {
    addParam: '添加参数',
    name: '参数名',
    type: '参数类型',
    example: '示例值',
    desc: '说明',
    addTitle: '添加参数',
    namePlaceholder: '请输入参数名称',
    typePlaceholder: '请选择参数类型',
    examplePlaceholder: '请输入示例值',
    descPlaceholder: '请输入参数说明',
    cancel: '取 消',
    ok: '确 认',
    errorInfo: '格式不正确'
  },
  editAreaText: {
    format: '格式化',
    copy: '复制',
    maxLengthTip: '示例长度不能超过',
    formatError: '格式化失败！该数据无法解析',
    formatSuccess: '格式化成功',
    copySuccess: '复制成功',
  },
  requestDataBox: {
    title: 'Body类型：',
    addData: '添加数据',
    name: '参数名',
    position: '参数位置',
    type: '参数类型',
    required: '是否必填',
    yes: '是',
    no: '否',
    example: '示例值',
    desc: '描述',
    addTitle: '添加参数',
    namePlaceholder: '请输入参数名称',
    positionPlaceholder: '请选择参数位置',
    typePlaceholder: '请选择参数类型',
    requiredPlaceholder: '请选择是否必填',
    examplePlaceholder: '请输入示例值',
    descPlaceholder: '请输入参数说明',
    cancel: '取 消',
    ok: '确 定'
  },
  configDist: {
    addData: '新增数据',
    notBlack:'输入内容不能为空',
    isDeleteContent: '是否删除该条数据？',
  },
  dictionariesTable: {
    string: '字符串',
    file: '文件',
    parameterName: '字典',
    parameterCloumn: '英文'
  },
  dictionariesTree: {
    placeholder: '请输入内容',
    allType: '全部分类',
    deleteContent: '此操作将永久删除该文件, 是否继续?',
  },
  eleHead: {
    loginOut: '退出',
    tipContent: '请注意，该操作将会退出系统',
    tipTitle: '友情提示',
    loginOutMsg: '退出系统成功'
  },
  requestSelect: {
    networkError: '请求失败，',
    refresh: '点击刷新',
    loading: '加载中...',
  },
  titleTable: {
    pushRecord: '推送记录',
    upgradeRecord: '推送记录',
  },
}


// WEBPACK FOOTER //
// ./src/components/components.zh-CN.js